module.exports = __webpack_public_path__ + "img/chatgpt.2fa552ac.svg";